import { useTranslation } from 'react-i18next';
import { FullScreenError } from 'components/FullScreen';

export function ErrorRoute() {
  const { t } = useTranslation();
  return <FullScreenError message={t('ui.io.invite.error.generic_error')} />;
}
